import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";

//   <StrictMode>
//     <App />
//   </StrictMode>

const root = createRoot(document.getElementById("root"));
root.render(
    <App />
);